(function () {
    'use strict';

    angular.module('itxApp.common').service('HomeParseUrl', HomeParseUrl);

    HomeParseUrl.$inject = ['homeManagerSvc'];

    function HomeParseUrl(homeManagerSvc) {
        var expressionProductURl = /.*c(\d{1,8})p?(\d{6,8})?.*/;

        var HomeParseUrl = {
            getShareUrl: getShareUrl,
            getEncodeUrl: getEncodeUrl
        };

        return HomeParseUrl;

        function getShareUrl(iParams) {
            var lastStoreCache = homeManagerSvc.getLastStore(true);
            var _categoryId, _productId, _shareUrl;
            var expArray;
            if (iParams) {
                _categoryId = iParams.categoryId;
                _productId = iParams.productId;
                _shareUrl = iParams.shareUrl;
            }
            if (
                (!_productId || !_categoryId) &&
                expressionProductURl.test(document.location.href)
            ) {
                expArray = expressionProductURl.exec(document.location.href);
                _categoryId = expArray[1];
                if (expArray.length >= 3) {
                    _productId = expArray[2];
                }
            }

            if (lastStoreCache && lastStoreCache.storeId && lastStoreCache.langId) {
                inditex.removeLocalStorage('REDIRECT_CATEGORY');
                inditex.removeLocalStorage('REDIRECT_STATIC_URL');
                // Si tenemos guardado StoreId y LangId generamos url dinamica

                if (_productId) {
                    return inditex.encodeUrl({
                        action: 'ItxProductPage',
                        params: {
                            storeId: lastStoreCache.storeId,
                            langId: lastStoreCache.iLangId,
                            categoryId: _categoryId,
                            productId: _productId
                        }
                    });
                //TODO Solicitud Andres CSM
                } else if (_shareUrl.indexOf('es/valentines-day-n1867')!==-1) {
                    return inditex.encodeUrl({
                        action: 'ItxHomePage',
                        params: {
                            storeId: lastStoreCache.storeId,
                            langId: lastStoreCache.iLangId,
                        }
                    }) +'c2051176.html';
                    
                } else if (_categoryId) {
                    return inditex.encodeUrl({
                        action: 'ItxCategoryPage',
                        params: {
                            storeId: lastStoreCache.storeId,
                            langId: lastStoreCache.iLangId,
                            categoryId: _categoryId
                        }
                    });
                } else if (_shareUrl) {
                    var pathRedirect = _shareUrl.replace(window.location.origin+'/es/', '').split('/');
                    return inditex.encodeUrl({
                        action: 'ItxHomePage',
                        params: {
                            storeId: lastStoreCache.storeId,
                            langId: lastStoreCache.iLangId,
                        }
                    }) + pathRedirect.join('/');
                }
            }
             else {
                // Si no tenemos StoreId y LangId navegamos a la WorldWide y guardamos la categoria a la que queriamos ir
                if (_categoryId) {
                    inditex.setLocalStorage(
                        'REDIRECT_CATEGORY',
                        JSON.stringify({
                            categoryId: _categoryId,
                            productId: _productId
                        })
                    );
                } else if (_shareUrl.indexOf('es/valentines-day-n1867')!==-1) {
                    inditex.setLocalStorage(
                        'REDIRECT_CATEGORY',
                        JSON.stringify({
                            categoryId: 2051176,
                            productId: null
                        })
                    );
                } else {
                    inditex.setLocalStorage(
                        'REDIRECT_STATIC_URL',
                        JSON.stringify({
                            shareUrl: iParams.shareUrl
                        })
                    );
                }
                return inditex.encodeUrl({
                    action: 'ItxWorldWidePage',
                    params: {}
                });
            }
        }

        function getEncodeUrl(store, langId, useHostName) {
            var url0, url1, i, c;

            url0 = inditex.decodeUrl(location.href);
            url1 = null;

            delete url0.params.useCookie;
            delete url0.params['select-store'];
            delete url0.params['redirect'];

            if (url0.params.shareUrl) {
                url1 = inditex.decodeUrl(url0.params.shareUrl);

                if (url0.host == url1.host) {
                    if (url1.params.storeId) {
                        url1.params.storeId = store.id;
                    }

                    if (url1.params.langId) {
                        url1.params.langId = langId ? langId : store.supportedLanguages[0].id;
                    }

                    if (url1.params.catalogId) {
                        c = inditex.getCatalogByType(store, url1.isMobile ? 5 : 1);
                        url1.params.catalogId = c ? c.id : null;
                    }
                }
                inditex._handleRedirectMappings(url1, useHostName);
                delete url0.params.shareUrl;
            }

            if (url1 == null) {
                c = inditex.getCatalogByType(store, url0.isMobile ? 5 : 1);
                url1 = {
                    action: 'ItxHomePage',
                    params: {
                        storeId: store.id,
                        langId: langId ? langId : store.supportedLanguages[0].id,
                        catalogId: c ? c.id : null
                    }
                };
            }

            for (i in url0.params) {
                if (url1.params[i] === undefined) {
                    url1.params[i] = url0.params[i];
                }
            }

            url1.hash = url0.hash;

            var isMobile = false;
            if (typeof url1.isMobile == 'boolean') {
                isMobile = url1.isMobile;
            } else {
                isMobile = inditex.iIsMobile;
            }
            var httpPort = isMobile
                ? inditex.iProxyPortMobile != 80
                    ? ':' + inditex.iProxyPortMobile
                    : ''
                : inditex.iProxyPortStandard != 80
                ? ':' + inditex.iProxyPortStandard
                : '';
            var httpsPort = isMobile
                ? inditex.iProxySecurePortMobile != 443
                    ? ':' + inditex.iProxySecurePortMobile
                    : ''
                : inditex.iProxySecurePortStandard != 443
                ? ':' + inditex.iProxySecurePortStandard
                : '';

            //Las urls de los paises en la worldwide irán por https o http en función del campo isHttpsEnabled del json del pais en cuestión.
            var isHttpsEnabled = store.isHttpsEnabled;
            var storeUrl = inditex.encodeUrl(url1, useHostName);
            var host;
            if (isHttpsEnabled && storeUrl.indexOf('http://') === 0) {
                storeUrl = storeUrl.replace('http://', 'https://');
                if (httpPort !== '') {
                    storeUrl = storeUrl.replace(httpPort, httpsPort);
                } else if (httpsPort !== '') {
                    host = storeUrl.split('https://')[1].split('/')[0];
                    storeUrl = storeUrl.replace(host, host + httpsPort);
                }
            } else if (!isHttpsEnabled && storeUrl.indexOf('https://') === 0) {
                storeUrl = storeUrl.replace('https://', 'http://');
                if (httpsPort !== '') {
                    storeUrl = storeUrl.replace(httpsPort, httpPort);
                } else if (httpPort !== '') {
                    host = storeUrl.split('http://')[1].split('/')[0];
                    storeUrl = storeUrl.replace(host, host + httpPort);
                }
            }

            return storeUrl;
        }
    }
})();
